import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import React from "react";
var __jsx = React.createElement;
import classNames from "classnames";
import FormControl from "../DynamicForm/FormControl";
var Checkbox = function Checkbox(props) {
  var id = props.id,
    label = props.label,
    checked = props.checked,
    onChange = props.onChange,
    _props$className = props.className,
    className = _props$className === void 0 ? "" : _props$className,
    disabled = props.disabled,
    name = props.name,
    child = props.child,
    _props$labelClassName = props.labelClassName,
    labelClassName = _props$labelClassName === void 0 ? "" : _props$labelClassName;
  return /*#__PURE__*/React.createElement("div", {
    className: classNames("relative flex items-center", _defineProperty({
      "opacity-50": disabled
    }, className, !!className))
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center"
  }, /*#__PURE__*/React.createElement("input", {
    id: id,
    "aria-describedby": id,
    name: name !== null && name !== void 0 ? name : id,
    type: "checkbox",
    className: classNames("rounded dark:border-gray-400 cursor-pointer text-teal-400 bg-transparent", {
      "!cursor-not-allowed": disabled
    }),
    checked: checked,
    onClick: function onClick(e) {
      var target = e.target;
      if (target.checked) {
        onChange ? onChange(target.checked, id) : null;
      } else {
        onChange ? onChange(false, id) : null;
      }
    },
    disabled: disabled
  })), /*#__PURE__*/React.createElement("label", {
    htmlFor: id,
    className: classNames("ml-3 text-gray-700 dark:text-gray-200 cursor-pointer text-base text-left w-full break-words", _defineProperty({
      "!cursor-not-allowed": disabled
    }, labelClassName, !!labelClassName))
  }, label), child && /*#__PURE__*/React.createElement(FormControl, {
    control: child
  }));
};
export default Checkbox;